import { Image } from '@/components/ui';
import { cn } from '@/lib/utils';

interface EventHeroProps {
  event: {
    name: string;
    subtitle?: string | null;
    description?: string | null;
    banner_image?: string | null;
  };
  /**
   * `full` on the overview, `slim` on every other tab: sub-pages already name
   * the event in their header, so the banner becomes a strip rather than a
   * third of the viewport.
   */
  variant?: 'full' | 'slim';
}

export function EventHero({ event, variant = 'full' }: EventHeroProps) {
  if (!event.banner_image) return null;
  return (
    <div
      data-event-hero
      data-variant={variant}
      className={cn(
        'bg-background relative w-full overflow-hidden',
        variant === 'slim' ? 'h-16' : 'h-32 lg:h-60',
      )}
    >
      <Image
        src={event.banner_image}
        alt={event.name}
        fill
        className="object-cover"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1200px"
        priority
      />
    </div>
  );
}
